import { ComponentProps, forwardRef, MouseEvent } from 'react';
import { Input } from '../Input';
import { SearchInputButtonWrap } from './SearchInputButtonWrap';
import { SearchInputClearWrap } from './SearchInputClearWrap';

export interface ISearchInputProps extends ComponentProps<typeof Input> {
	onClickSearch: (e: MouseEvent) => void;
	onClickClear: (e: MouseEvent) => void;
	showClearIcon: boolean;
	placeholder?: string;
	ariaLabel?: string;
	buttonAriaLabel?: string;
	placeholderAsLabel?: boolean;
	className?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, ISearchInputProps>(
	(
		{
			onClickSearch,
			showClearIcon,
			onClickClear,
			placeholder,
			disabled,
			ariaLabel,
			buttonAriaLabel,
			className,
			...rest
		}: ISearchInputProps,
		ref,
	) => (
		<SearchInputButtonWrap
			onClickSearch={onClickSearch}
			disabled={disabled}
			ariaLabel={buttonAriaLabel}
			className={className}
		>
			<SearchInputClearWrap
				onClickClear={onClickClear}
				showClearIcon={showClearIcon}
			>
				<Input
					disabled={disabled}
					ref={ref}
					aria-label={ariaLabel ?? placeholder}
					placeholder={placeholder}
					{...rest}
				/>
			</SearchInputClearWrap>
		</SearchInputButtonWrap>
	),
);
